import { doc, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { db } from '../firebase-config';

function ChatItem({user1, user,chatPersonImg, chatPersonName, lastSeen, msgCount, mssgPrev, handleChatClick, }) {
    const user2 = user?.uid;
  const [data, setData] = useState("");

  useEffect(() => {
    if(user){
        const id = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`;
    let unsub = onSnapshot(doc(db, "lastMsg", id), (doc) => {
      setData(doc.data());
    });
    return () => unsub();
    }
  }, []);
    return (
        <ChatItemWrap  onClick={handleChatClick}>
            <ChatPerson>
           
                <div className='chat_person'>
                <div className="img_cont">
                <img src={chatPersonImg} alt="" />
                <span style={{background: user?.isOnline === true ? "green" : "red"}} className="user_status"></span>
                </div>


                <div className='name_seen__box'>
                    <label className='chat_per_name'>{chatPersonName}</label>
                    <label className='chat_last_seen'>{lastSeen}</label>
                </div>

                </div>
                <label className='chat_count'>{msgCount}</label>
            </ChatPerson>  
               
            <ChatPreview>
            {
                    data && 
                    <p className="truncate">
                       <strong>{data.from === user1? "Me:": null}</strong> 
                        {data.textMessage}
                    </p>
                }
            </ChatPreview>
        </ChatItemWrap>
    )
}

export default ChatItem

const ChatItemWrap = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.body};
    width: 85%;
    height: 7rem;
    padding: 0.8rem;
    margin: 0.4rem 0rem;
    border-radius: 6px;

`
const ChatPerson = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    


    .chat_person {
        display: flex;
        align-items: center;

    }  

    .img_cont {
        position: relative;

    }

    .chat_person img {
        width: 40px;
        height: 40px;
        border-radius: 100%;

    }
    .name_seen__box {
        display: flex;
        flex-direction: column;
        padding-left: 0.6rem;
        height: 100%;
        justify-content: space-between;
    }
    .chat_per_name {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 21px;

    }
    .chat_last_seen {
        font-family: Montserrat;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: ${({ theme }) => theme.text}
    }

    .chat_count {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ theme }) => theme.text};
        font-size: 0.8rem;
        background: var(--p-red);
        width: 20px;
        height: 20px;
        border-radius: 100%;
    }
    .user_status {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        position: absolute;
        right: 0;
        bottom: 5px;
    }
`
const ChatPreview = styled.div`
  
p {
    font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 26px;
color: ${({ theme }) => theme.text};
padding: 1rem;
margin: 1rem 0rem;
}

.truncate {
  font-size: 14px;  
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.truncate strong {
    margin-right: 10px;
}

`